export default [
  {
    key: 'all',
    label: 'report.object.intervals.all',
  },
  {
    key: 'fiveMinutes',
    label: 'report.object.intervals.5minutes',
  },
  {
    key: 'tenMinutes',
    label: 'report.object.intervals.10minutes',
  },
  {
    key: 'fifteenMinutes',
    label: 'report.object.intervals.15minutes',
  },
  {
    key: 'thirtyMinutes',
    label: 'report.object.intervals.30minutes',
  },
  {
    key: 'sixtyMinutes',
    label: 'report.object.intervals.60minutes',
  },
]
